import { useFormikContext } from 'formik'
import { AlertType } from 'src/components/shared/ui/AlertDialog/enums'
import ShowErrorsDialog from 'src/components/shared/ui/ShowErrorsDialog/ShowErrorsDialog'
import { EscritosFormValues } from 'src/components/views/EscritosLexnet/components/shared/types/escritosFormTypes'
import { useAlertContext } from 'src/contexts/AlertContext'
import { FormField } from 'src/enums/Form'

type ReturnObject = {
  clearForm: () => void
  submit: () => void
}

function useSubmitFormActions(): ReturnObject {
  const { resetForm, validateForm } = useFormikContext<EscritosFormValues>()
  const { addAlert } = useAlertContext()

  function clearForm() {
    resetForm()
    // setTimeout(() => {
    //   // validateForm()
    // })
  }

  function closeWarning(fieldId: string) {
    if (document) {
      const main = document.querySelector('main')
      const selectedElement = document.querySelector(`#${fieldId}`)

      if (main && selectedElement) {
        const selectedElementCoords = selectedElement.getBoundingClientRect()
        main.scrollTo({
          top: selectedElementCoords.top + main.scrollTop - 250,
          behavior: 'smooth'
        })
      }
    }
  }

  async function submit() {
    const errors = await validateForm()

    if (Object.keys(errors).length && !errors[FormField.EXCESO_CABIDA]) {
      const firstErrorId = Object.keys(errors)[0]
      addAlert({
        message: (
          <ShowErrorsDialog
            errors={errors}
            // documentoPrincipal={values[FormField.DOCUMENTO_PRINCIPAL][0]}
          />
        ),
        type: AlertType.ERROR,
        closeAction: () => closeWarning(firstErrorId)
      })
    }
  }

  return {
    clearForm,
    submit
  }
}

export default useSubmitFormActions
